<template>
    <app-dialog :value="isShippingCostsDialogOpen" @input="$emit('input', $event)" :title="$t('shippingCosts.title')" :width="getDialogWidth" data-cy="shipping-costs-dialog">
        <template v-slot:content>
            <span class="font-size-md description-text shipping-cost-content" v-html="tHtml(shippingCost.content)"></span>

            <v-checkbox v-model="ckUnderstandShippingCosts" data-cy="shipping-costs-cbx">
                <template v-slot:label>
                    <strong style="font-size: 14px !important; line-height: 0px !important"> {{ $t('shippingCosts.understand') }} </strong>
                </template>
            </v-checkbox>
        </template>

        <template v-slot:buttons>
            <v-btn text outlined class="myprovet-btn-cancel px-8" @click="$emit('input', false)"> {{ $t('common.back') }} </v-btn>

            <v-btn text class="myprovet-btn-ok px-8" @click="confirm" data-cy="shipping-costs-ok-btn"> {{ $t('shippingCosts.next') }} </v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';

export default {
    props: {
        isShippingCostsDialogOpen: {
            type: Boolean,
            default: false,
        },
        shippingCost: Object,
        branchShippingOfferValue: Number,
        shoppingCartSubtotal: Number,
    },

    data: () => ({
        ckUnderstandShippingCosts: false,
        offerMissingValue: 0,
    }),

    computed: {
        ...mapStores(useBranchStore),

        getDialogWidth() {
            return this.getResponsiveDialogWidth('60vw', '40vw');
        },
    },

    watch: {
        isShippingCostsDialogOpen: {
            handler: function () {
                this.ckUnderstandShippingCosts = false;
            },
            immediate: true,
        },

        shoppingCartSubtotal: {
            handler: function () {
                this.offerMissingValue = this.formatPrice(this.branchShippingOfferValue - this.shoppingCartSubtotal);
            },
            immediate: true,
        },
    },

    methods: {
        confirm() {
            if (this.ckUnderstandShippingCosts) {
                this.$emit('try-open-pending-products-dialog');
            } else {
                this.showError(this.$t('shippingCosts.confirmError'));
            }
        },
    },
};
</script>
